export const MERCHANT_OWNER_ROLE = 'merchant_owner' as const;
export const MERCHANT_STAFF_ROLE = 'merchant_staff' as const;
export const CONSUMER_ROLE = 'consumer' as const;

export type MerchantRole =
  | typeof MERCHANT_OWNER_ROLE
  | typeof MERCHANT_STAFF_ROLE
  | typeof CONSUMER_ROLE;

export function isMerchantRole(value: unknown): value is MerchantRole {
  return value === MERCHANT_OWNER_ROLE || value === MERCHANT_STAFF_ROLE || value === CONSUMER_ROLE;
}

export function isMerchantOwner(role: MerchantRole | null | undefined): boolean {
  return role === MERCHANT_OWNER_ROLE;
}

export function filterOwnerOnlyItems<T extends { ownerOnly?: boolean }>(
  items: T[],
  role: MerchantRole | null | undefined,
): T[] {
  if (isMerchantOwner(role)) {
    return items;
  }

  return items.filter((item) => !item.ownerOnly);
}
